import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'zikata-frontend-token-sent',
  templateUrl: './token-sent.component.html',
  styleUrls: ['./token-sent.component.scss']
})
export class TokenSentComponent {

  @Input() title = 'Check your email';
  @Input() recipient: string | undefined;
  @Input() recipientMessage = 'We sent password reset link to';
  @Input() noReceiveQuestion = 'Did not receive the email?';
  @Output() resend: EventEmitter<undefined> = new EventEmitter<undefined>();
  @Output() goBack: EventEmitter<undefined> = new EventEmitter<undefined>();

}
